import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lstOfs: [],
        ofs: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getInsert(state) {
            return state.insert
        },
        getOfs(state, getters, rootState) {
            let ofs = { ...state.ofs }
            ofs.ofsresptec = rootState.dc4.dc4.dc4usuario
            return ofs
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        }
    },
    mutations: {
        set(state, ofs) {
			state.ofs = {
                ...ofs,
                analysis: ofs?.analysis ?? [],
                lstInj: ofs?.lstInj ?? [],
                lstOfz: ofs?.lstOfz ?? []
            }
            if (ofs)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofs = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfs = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfs(state, ofs) {
            state.ofs = ofs
        },
        setAnalysis(state, analysis) {
            state.ofs = {
                ...state.ofs,
                analysis: analysis ?? []
            }
        },
        setLstOfs(state, lstOfs) {
            state.lstOfs = lstOfs
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofsanalise) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/Analysis/Find/${ofsanalise}`)
                .then(response => {
                    let ofs = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofs)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, ofsanalise) {
            return await this._vm.$axios.get(`/Oryxplace/Analysis/Find/${ofsanalise}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (!getters.getInsert) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/Analysis/Insert", getters.getOfs)
                .then(response => {
                    let ofs = Utils.ValidateAxiosResponse(response.data);
                    commit('setLastUpdatedRegister', ofs);
                    commit("set", ofs)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/Analysis/Update", getters.getOfs)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async updateBatchApproval({ state, dispatch, commit }, { approveBatch }) {
            dispatch(
                "parameters/openGlobalLoading",
                { showLoadingGlobal: true, text: approveBatch ? "Aprovando lote" : "Reprovando lote", indeterminate: true },
                { root: true }
            )

            try {
                const ofsanalise = state.ofs.ofsanalise

                const response = await this._vm.$axios.put(
                    `/Oryxplace/Analysis/updateBatchApproval`,
                    null,
                    {
                        params: { ofsanalise, approveBatch }
                    }
                )

                const ofs = Utils.ValidateAxiosResponse(response.data)

                commit("set", ofs)
                commit("setLastUpdatedRegister", ofs)

                return true
            } catch (error) {
                dispatch(
                    "parameters/openDialog",
                    {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message || "Erro ao aprovar lote"
                    },
                    { root: true }
                )
                return false
            } finally {
                dispatch(
                    "parameters/openGlobalLoading",
                    { showLoadingGlobal: false, text: "" },
                    { root: true }
                )
            }
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/Analysis/Delete/${getters.getOfs.ofsordem}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    window.location.reload(true)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findByOrder({ commit, dispatch }, ofsordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/Analysis/FindByOrder/${ofsordem}`)
                .then(response => {
                    let ofs = Utils.ValidateAxiosResponse(response.data);
                    commit("set", ofs)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async findAnalysis({ commit, dispatch }, ofsordem) {
            commit("setLoading", true)

            try {
                const response = await this._vm.$axios.get(
                `/OryxPlace/Analysis/FindAnalysis/${ofsordem}`
                )

                const analysis = Utils.ValidateAxiosResponse(response.data)
                commit("setAnalysis", analysis)

                return analysis
            }
            catch (error) {
                dispatch(
                "parameters/openDialog",
                {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message,
                },
                { root: true }
                )

                return null  
            }
            finally {
                commit("setLoading", false)
            }
        },
        async findRecipByCode({ state, dispatch }, idRecip) {
            await this._vm.$axios.get(`/Oryxplace/Analysis/FindRecipByCode/${idRecip}`)
                .then(response => {
                    let ofs = Utils.ValidateAxiosResponse(response.data)
                    if (!ofs) {
                        throw new Error()
                    }    
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: "Cilindro não encontrado"
                    }, { root: true })
                    this.state.ofs.ofs.ofscodcil = ''
                    return false
                });
        },
    }
}